(() => {
  const expire = () => {
    const now = Math.floor(Date.now() / 1000);
    document.querySelectorAll('[data-againora-promo-until]').forEach(node => {
      const until = Number(node.getAttribute('data-againora-promo-until'));
      if (!Number.isFinite(until) || until <= now) node.hidden = true;
    });
  };
  expire();
  window.setInterval(expire, 15000);
  document.addEventListener('visibilitychange', expire);
  document.addEventListener('shopify:section:load', expire);
  // Delegation covers replaced cart sections. Copying never means applied.
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-againora-copy]');
    if (!button) return;
    const feedback = button.closest('.againora-coupon')?.querySelector('.againora-coupon__feedback');
    try {
      await navigator.clipboard.writeText(button.dataset.againoraCopy);
      const label = button.querySelector('.againora-coupon__copy-label');
      label.textContent = button.dataset.copied;
      if (feedback) feedback.textContent = button.dataset.copied;
    } catch {
      const selection = window.getSelection();
      const range = document.createRange();
      range.selectNodeContents(button.querySelector('.againora-coupon__code'));
      selection?.removeAllRanges();
      selection?.addRange(range);
      if (feedback) {
        feedback.classList.remove('visually-hidden');
        feedback.textContent = button.dataset.copyFailed;
      }
    }
  });
  new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('[data-againora-promo-until]') || node.querySelector('[data-againora-promo-until]'))))) expire();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
